import { useParams } from "react-router-dom";
import DraftSubmissionBody from "./components/draftSubmissionBody";
import DraftSubmissionHeader from "./components/draftSubmissionHeader";
import ErrorComponent from "./components/error";
import Loader from "./components/loader";
import { useDraftSubmission } from "./hooks/useDraftSubmission";

const DraftSubmission = () => {
  const { id: orderId } = useParams();
  const { draftSubmission, loading, error } = useDraftSubmission(orderId);
  return (
    <div className="draft-submission--container flex h-full w-full items-center justify-center overflow-hidden py-11">
      {loading && <Loader />}
      {error && <ErrorComponent />}
      {draftSubmission && draftSubmission?.length > 0 && (
        <>
          <div className="draft-submission--content flex h-full w-3/4 flex-col gap-8 overflow-hidden">
            <div className="draft-submission--header">
              <DraftSubmissionHeader />
            </div>
            <div className="draft-submission--body flex-1 overflow-hidden rounded-md border border-primaryGray-15 bg-white p-5">
              <DraftSubmissionBody draftSubmission={draftSubmission} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DraftSubmission;
